//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, Outlet } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import Footer from "../../component/common/Footer";
import MyPageMenu from "../../component/content/MyPageMenu";
import MyPageLevelBox from "../../component/content/MyPageLevelBox";
import InnerCon from "../../component/layouts/InnerCon";

// modal
import DeliveryModal from "../../component/popup/DeliveryModal";
import DefaultModal from "../../component/popup/DefaultModal";

// responsive
import { M, T } from "../../utils/MT";

export default function DefaultMyPage() {
    // 프리오더일때, 아닐때
    const [preOrder, setPreOrder] = useState(false);

    // 모달리스트
    // 1. 배송 조회 팝업
    const [deliveryModal, setDeliveryModal] = useState(false);

    //  1. 배송 조회 팝업
    const DeliveryModalCon = () => {
        return <DeliveryModal setDeliveryModal={setDeliveryModal} />;
    };

    return (
        <>
            <Wrap>
                <Header />
                <InnerCon>
                    <InnerWrap>
                        <PC>
                            {/* <MyPageTitle>MY PAGE</MyPageTitle> */}
                            {/* 마이페이지 사이드 메뉴 */}
                            <MenuContent>
                                <MyPageMenu preOrder={preOrder} />
                            </MenuContent>
                        </PC>

                        <MyPageSection>
                            {/* 마이페이지 상단 등급 메뉴 */}
                            <PC>
                                <MyPageLevelBox preOrder={preOrder} />
                            </PC>

                            {/* 마이페이지 컨텐츠 들어가는 곳 */}
                            <Outlet preOrder={preOrder} setDeliveryModal={setDeliveryModal} context={{ setDeliveryModal }} />
                        </MyPageSection>
                    </InnerWrap>
                </InnerCon>
                <Footer />
            </Wrap>

            {/* 모달리스트 */}
            {/* 1. 배송조회 모달 */}
            {deliveryModal && <DefaultModal closeModal={() => setDeliveryModal(false)} contents={DeliveryModalCon} />}
        </>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
const InnerWrap = styled.div`
    position: relative;

    display: flex;
    justify-content: space-between;

    width: calc(100vw * (1060 / 1920));
    margin: calc(100vw * (40 / 1920)) auto calc(100vw * (165 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: calc(100vw * (40 / 1300)) auto calc(100vw * (165 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        justify-content: unset;
        width: 100vw;
        margin: ${M(30)} auto ${M(100)};
    }
`;
const MyPageTitle = styled.h2`
    font-size: calc(100vw * (40 / 1920));
    font-family: "Pop-L";
    line-height: 1;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        padding-left: ${M(25)};
    }
`;
const MenuContent = styled.nav`
    flex-shrink: 0;
    width: calc(100vw * (140 / 1920));

    margin-right: calc(100vw * (80 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (140 / 1300));

        margin-right: calc(100vw * (80 / 1300));
    }
`;
const MyPageSection = styled.div`
    /* flex: 1; */
    width: calc(100% - 100vw * (220 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (220 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;
